export const priceFormate = (srcNumber) => {
  const formattedPrice =
    new Intl.NumberFormat("kz-KZ").format(Math.round(srcNumber)).replaceAll(",", " ") +
    " ₸";

  return formattedPrice;
};
